import axios from 'axios';

export default {
  listBO(params = {}) {
    return axios.get('/v1/budgets/codes', { params });
  },
  listTaxo(params = {}) {
    return axios.get('/v1/budgets/taxonomy', { params });
  },
  addBudget(body) {
    return axios.put('/v1/budgets/add', body);
  },
  transferBudget(body) {
    return axios.put('/v1/budgets/transfer', body);
  },
  history(params = {}) {
    return axios.get('/v1/budgets/movement-logs', { params });
  }
};
